import lv0 from '@/assets/imageIntegral/lv0.png';
import lv1 from '@/assets/imageIntegral/lv1.png';
import lv2 from '@/assets/imageIntegral/lv2.png';
import lv3 from '@/assets/imageIntegral/lv3.png';
import lv4 from '@/assets/imageIntegral/lv4.png';
import lv01 from '@/assets/imageIntegral/lv0-1.png';
import lv11 from '@/assets/imageIntegral/lv1-1.png';
import lv21 from '@/assets/imageIntegral/lv2-1.png';
import lv31 from '@/assets/imageIntegral/lv3-1.png';
import lv41 from '@/assets/imageIntegral/lv4-1.png';
import lock from '@/assets/imageIntegral/lock.png';
import right from '@/assets/imageIntegral/向右.png';
import yellowRight from '@/assets/imageIntegral/yellow_向右.png';
//
import taskTypeAll from '@/assets/imageIntegral/任务类型.png';
import taskNum from '@/assets/imageIntegral/任务领取数量.png';
import badge1 from '@/assets/imageIntegral/badge-1个.png';
import badge2 from '@/assets/imageIntegral/badge-2个.png';
import badge5 from '@/assets/imageIntegral/badge-5个.png';
import badge10 from '@/assets/imageIntegral/badge-10个.png';
import badge20 from '@/assets/imageIntegral/badge-20个.png';
import badgeMarshalling from '@/assets/imageIntegral/badge-编组.png';
import badgePart from '@/assets/imageIntegral/badge-部分.png';
//
import unActivities from '@/assets/imageIntegral/运营活动-灰.png';
import activities from '@/assets/imageIntegral/运营活动.png';
import unMall from '@/assets/imageIntegral/积分商城-灰.png';
import mall from '@/assets/imageIntegral/积分商城.png';
import unMeet from '@/assets/imageIntegral/线下见面会-灰.png';
import meet from '@/assets/imageIntegral/线下见面会.png';
import unExclusive from '@/assets/imageIntegral/尊享功能-灰.png';
import exclusive from '@/assets/imageIntegral/尊享功能.png';
//
import img0 from '@/assets/imageIntegral/可领任务类型.png';
import img1 from '@/assets/imageIntegral/任务占用上限.png';
// import img2 from '@/assets/imageIntegral/参与运用活动.png';
import img2 from '@/assets/imageIntegral/线上活动.png';
import img3 from '@/assets/imageIntegral/积分兑换.png';
import img4 from '@/assets/imageIntegral/线下见面会-detail.png';
import img5 from '@/assets/imageIntegral/功能优先体验.png';
import imgLevelRecover from '@/assets/imageIntegral/等级回升.png'
import imgLevelRecover_grey from '@/assets/imageIntegral/等级回升-灰.png'
import imgLevelRecover_little from '@/assets/imageIntegral/等级回升-小.png'
import imgLevelQuickRecover from '@/assets/imageIntegral/等级快速回升.png'
import imgLevelQuickRecover_grey from '@/assets/imageIntegral/等级快速回升-灰.png'
import imgLevelQuickRecover_little from '@/assets/imageIntegral/等级快速回升-小.png'
import imgRecoverBannerLV3 from '@/assets/imageIntegral/回升-lv3.png'
import imgRecoverBannerLV4 from '@/assets/imageIntegral/回升lv4.png'
import imgQuickRecoverBannerLV4 from '@/assets/imageIntegral/快速回升-lv4.png'
import imgRecoverBanner from '@/assets/imageIntegral/回升-底图.png'
import imgQuickRecoverBanner from '@/assets/imageIntegral/快速回升-底图.png'
import imgRecoverAlertBanner from '@/assets/imageIntegral/通知-底图.png'
import imgRecoverAlertStepBanner from '@/assets/imageIntegral/通知-进度底图.png'
import closeIcon from '@/assets/imageIntegral/cclose.png'

export {
  lv0,
  lv1,
  lv2,
  lv3,
  lv4,
  lv01,
  lv11,
  lv21,
  lv31,
  lv41,
  lock,
  right,
  yellowRight,
  //
  taskTypeAll,
  taskNum,
  badge1,
  badge2,
  badge5,
  badge10,
  badge20,
  badgeMarshalling,
  badgePart,
  //
  unActivities,
  activities,
  unMall,
  mall,
  unMeet,
  meet,
  unExclusive,
  exclusive,
  //
  img0,
  img1,
  img2,
  img3,
  img4,
  img5,
  imgLevelRecover,
  imgLevelRecover_grey,
  imgLevelRecover_little,
  imgLevelQuickRecover,
  imgLevelQuickRecover_grey,
  imgLevelQuickRecover_little,
  imgRecoverBannerLV3,
  imgRecoverBannerLV4,
  imgQuickRecoverBannerLV4,
  imgRecoverBanner,
  imgQuickRecoverBanner,
  imgRecoverAlertBanner,
  imgRecoverAlertStepBanner,
  closeIcon,
};
